export default __webpack_public_path__ + "static/media/Twitter.89498832.png";